module.exports = __webpack_public_path__ + "img/流体力学4_1.0f1d51ac.jpg";